import React, { useState } from "react";
import { CheckCircle as IconDone } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";

import { INFO, SUCCESS, WARNINGS } from "common/lables";
import { COLORS } from "common/colors";
import { CRM_LEAD_STATUS, NOTIFY } from "common/config";
import { COMMON_JS } from "common/scripts";
import { CRM_APIs } from "apihandlers/crm";

const successAnimation = require("./assets/success.gif");
const successVideo = require("./assets/success.mp4");
const successGif = require("./assets/welcome.gif");

const Converted = (props: any) => {
  const { selectedRow, onClose } = props;
  const [status, setStatus] = useState(selectedRow.crmLeadStatus);

  const onConverted = async () => {
    try {
      const sure = window.confirm(WARNINGS.ARE_YOU_SURE);
      if (sure) {
        const args = {
          crmLeadId: selectedRow.id,
          crmLeadName: selectedRow.crmLeadName,
          activeStatus: "true",
          crmLeadStatus: CRM_LEAD_STATUS.CONVERTED,
        };
        const res = await CRM_APIs.manageCrmLeadProfile(args);
        if (res.status === 200) {
          COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
          setStatus(CRM_LEAD_STATUS.CONVERTED);
          setTimeout(() => {
            onClose();
          }, 5000);
        } else {
          COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
        }
      }
    } catch (error) {
      console.error("onConverted: ", error);
    }
  };

  return status === CRM_LEAD_STATUS.CONVERTED ? (
    <div className="flexColumn" style={{ alignItems: "center", marginTop: 60 }}>
      <div style={{ width: "30%" }}>
        <img src={successAnimation} style={{ width: "100%" }} />
        {/* <video src={successVideo} style={{ width: "100%" }} autoPlay loop /> */}
        {/* <img src={successGif} style={{ width: "100%" }} /> */}
      </div>
      <div className="flexRow" style={{ alignItems: "center" }}>
        <IconDone
          style={{ color: COLORS.GREEN, marginRight: 10, fontSize: "2rem" }}
        />
        <h4 style={{ color: COLORS.GREEN, fontSize: "1.5rem" }}>
          {INFO.CONGRATULATION_LEAD_CONVERTED}
        </h4>
      </div>
    </div>
  ) : (
    <div
      className="flexColumn"
      style={{
        alignItems: "center",
        marginTop: "5rem",
      }}
    >
      <div
        className="flexRow"
        style={{ width: "30%", justifyContent: "center" }}
      >
        <Btn text={CRM_LEAD_STATUS.CONVERTED} onClick={onConverted} />
      </div>
    </div>
  );
};

export default withSnackbar(Converted);
